"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resumeUserSession = exports.fetchUserSessionByMarketingId = exports.createUserSession = exports.SAVE_USER_SESSION_WITH_NO_STATUS_REPORT = exports.SAVE_USER_SESSION_SUCCESS = exports.SAVE_USER_SESSION_ERROR = exports.SAVE_USER_SESSION = exports.RESET_USER_SESSION = exports.FETCH_USER_SESSION_SUCCESS = exports.FETCH_USER_SESSION = exports.CREATE_USER_SESSION_SUCCESS = exports.CREATE_USER_SESSION = void 0;
var _appActions = require("../appActions");
const FETCH_USER_SESSION = 'FETCH_USER_SESSION';
exports.FETCH_USER_SESSION = FETCH_USER_SESSION;
const FETCH_USER_SESSION_SUCCESS = 'FETCH_USER_SESSION_SUCCESS';
exports.FETCH_USER_SESSION_SUCCESS = FETCH_USER_SESSION_SUCCESS;
const CREATE_USER_SESSION = 'CREATE_USER_SESSION';
exports.CREATE_USER_SESSION = CREATE_USER_SESSION;
const CREATE_USER_SESSION_SUCCESS = 'CREATE_USER_SESSION_SUCCESS';
exports.CREATE_USER_SESSION_SUCCESS = CREATE_USER_SESSION_SUCCESS;
const SAVE_USER_SESSION = 'SAVE_USER_SESSION';
exports.SAVE_USER_SESSION = SAVE_USER_SESSION;
const SAVE_USER_SESSION_SUCCESS = 'SAVE_USER_SESSION_SUCCESS';
exports.SAVE_USER_SESSION_SUCCESS = SAVE_USER_SESSION_SUCCESS;
const SAVE_USER_SESSION_ERROR = 'SAVE_USER_SESSION_ERROR';
exports.SAVE_USER_SESSION_ERROR = SAVE_USER_SESSION_ERROR;
const RESET_USER_SESSION = 'RESET_USER_SESSION';
exports.RESET_USER_SESSION = RESET_USER_SESSION;
const SAVE_USER_SESSION_WITH_NO_STATUS_REPORT = 'SAVE_USER_SESSION_WITH_NO_STATUS_REPORT';
exports.SAVE_USER_SESSION_WITH_NO_STATUS_REPORT = SAVE_USER_SESSION_WITH_NO_STATUS_REPORT;
const fetchUserSessionByMarketingId = marketingId => ({
  type: FETCH_USER_SESSION,
  payload: {
    marketingId
  }
});
exports.fetchUserSessionByMarketingId = fetchUserSessionByMarketingId;
const createUserSession = marketingId => ({
  type: CREATE_USER_SESSION,
  payload: {
    marketingId
  }
});
exports.createUserSession = createUserSession;
const resumeUserSession = sessionState => ({
  type: _appActions.INJECT_STATE,
  payload: {
    ...sessionState
  }
});
exports.resumeUserSession = resumeUserSession;